import _ from "lodash";
import {COLOR_STOP_LIST, GRADIENT_POSITION_OPTIONS_LIST} from "../../design/constants/design.constant";
import {COLOR_LIST} from "../constants/color.constant";

export {
    generateLinearGradientDetail,
    getColor,
}

const generateLinearGradientDetail = (noChangedDate = false) => {
    const positions = generateStartEndPositions();
    const stops = generateLinearGradientStops();
    const colorStops = [];
    const gradientColors = [];
    const stopsMap = _.keyBy(stops, 'offset.key');

    _.forEach(COLOR_STOP_LIST, (stopDetail) => {
        const stop = stopsMap[stopDetail.key];

        if (stop) {
            colorStops.push({
                ...stop.offset,
                checked: true,
                ...stop.color,
            });

            gradientColors.push(parseFloat(stop.offset?.label));
            gradientColors.push(stop.color?.hexCode);
        } else {
            colorStops.push({
                ...stopDetail,
                checked: false,
            });
        }

    });

    /*_.forEach(_.orderBy(stops, ['offset']), (stop) => {
        colorStops.push({
            ...stop.offset,
            checked: true,
            ...stop.color,
        });

        gradientColors.push(parseFloat(stop.offset?.label));
        gradientColors.push(stop.color?.hexCode);
    });*/

    const colorDetail = {
        colorType: 'linear',
        ...positions,
        gradientColorList: _.orderBy(colorStops, ['key']),
        gradientColors: gradientColors,
        changedDate: new Date().toISOString(),
    }

    if (noChangedDate) {
        delete colorDetail.changedDate;
    }

    return colorDetail;
}

const generateLinearGradientStops = () => {
    let numStops = Math.floor(Math.random() * 4) + 2; // Random number of stops between 2 and 7
    // let numStops = 3;
    let stops = [];

    // List of available offsets
    let offsets = _.cloneDeep(COLOR_STOP_LIST)
    // Shuffle the offsets array
    offsets.sort(function () {
        return 0.5 - Math.random()
    });

    // Generate random color stops
    for (let i = 0; i < numStops; i++) {
        let stop = {
            offset: offsets[i % offsets.length], // Pick offset value from the shuffled array
            color: getColor()
        };

        stops.push(stop);
    }

    return _.orderBy(stops, ['key']);
}

const getColor = () => {
    const colorDetail = getRandomItemFromList(COLOR_LIST);
    const colorCodeDetail = getRandomItemFromList(colorDetail.colorCodes);

    return {
        backgroundColorKey: colorDetail.colorKey,
        backgroundColorCodeKey: colorCodeDetail.colorCodeKey,
        hexCode: colorCodeDetail.hexCode,
    }
}

const generateStartEndPositions = () => {
    const startPointPosition = getRandomItemFromList(GRADIENT_POSITION_OPTIONS_LIST);
    const filteredPositions = _.filter(GRADIENT_POSITION_OPTIONS_LIST, (position) => {
        return startPointPosition.key !== position.key;
        // return startPointPosition.exclude.indexOf(position.key) === -1;
    });
    const endPointPosition = getRandomItemFromList(filteredPositions);

    return {
        startPoint: startPointPosition.key,
        endPoint: endPointPosition.key,
    }
}

function getRandomItemFromList(itemList) {
    let randomIndex = Math.floor(Math.random() * itemList.length);
    return itemList[randomIndex];
}
